import createTag from '../createTag';
import stripIndentTransformer from '../stripIndentTransformer';
import trimResultTransformer from '../trimResultTransformer';
var stripIndent = createTag(stripIndentTransformer(), trimResultTransformer('smart'));
export default stripIndent;